import { api } from 'api/common'
import { ALL_CHANGE_REQ, UPDATE_CHANGE_REQ } from 'api/constants'
import { setToastMessage } from 'components/app/actions'
import { createActionsHook } from 'react-redux-actions-hook'
import { loadBreakDown } from '../actions'
import { ApprovalsActionType } from './constants'

// Common load data wrapper
export const loadApprovals = (data = {}) => {
    return (dispatch, stateFn) => {
        const state = stateFn().approvals
        api(
            `${ALL_CHANGE_REQ}`,
            {
                method: 'POST',
                body: JSON.stringify({ ...state.table, ...data }),
            },
            dispatch,
        )
            .then((response) => {
                dispatch(setApprovals(response.data))
                dispatch(loadBreakDown())
            })
            .catch((error) => {
                //Handle Error
            })
    }
}

export const updatePendingUser = (approverOrDeny) => {
    return (dispatch, stateFn) => {
        const state = stateFn().approvals
        if (!state.editApproval.id) {
            return
        }
        api(
            `${UPDATE_CHANGE_REQ}/${state.editApproval.id}/${approverOrDeny}`,
            { method: 'PATCH', body: JSON.stringify({}) },
            dispatch,
        )
            .then((res) => {
                dispatch(
                    setToastMessage({
                        message: res.message,
                        type: 'success',
                    }),
                )
                dispatch(loadApprovals())
            })
            .catch((error) => {
                //Handle Error
            })
    }
}

export const setApprovals = (approvals) => {
    return { type: ApprovalsActionType.SET_APPROVALS, approvals }
}

export const setEditApproval = (data) => {
    return { type: ApprovalsActionType.SET_EDIT_APPROVAL, data }
}

export const setOrderBy = (orderBy) => {
    return { type: ApprovalsActionType.SET_ORDER_BY, orderBy }
}

export const setPagination = (paging) => {
    return { type: ApprovalsActionType.SET_PAGING_OPT, paging }
}

export const setFilter = (filters) => {
    return { type: ApprovalsActionType.SET_FILTER, filters }
}

export const setSearch = (search) => {
    return { type: ApprovalsActionType.SET_SEARCH_TEXT, search }
}

export const setPageOffset = (offset) => {
    return { type: ApprovalsActionType.SET_PAGE_OFFSET, offset }
}

export default createActionsHook({
    loadApprovals,
    setEditApproval,
    setOrderBy,
    setPagination,
    setFilter,
    setSearch,
    setPageOffset,
    updatePendingUser,
})
